<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/143SOqm/tc-custom/9780802193131.jpg?1705405931798" alt="This image is the cover for the book Our Lady of Babylon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Our Lady of Babylon
      </h1>
      <p class="bookDescription body article font2">
        <b>“A funny, sexy, stylistically elegant, tongue-in-cheek rewriting of history” from the <i>New York Times</i>–bestselling author of <i>City of Night</i> (<i>Booklist</i>).</b><br/>  <br/> A retelling of the stories of the fallen women of history, recounted by an eighteenth-century lady who realizes that these women’s lives bear a remarkable resemblance to her own. Told by a mystic that her dreams are memories of past lives, she must face the public to vindicate all women falsely accused of crimes.<br/>  <br/> “Mr. Rechy’s renditions of these seemingly familiar stories can . . . be surprisingly fresh, creating an ominous sense of tragedy and doom.” —<i>The New York Times Book Review</i><br/>  <br/> “With a colorful ribbon of feminist revisionism festooning its New Age wrapping, Rechy’s latest novel indulges in past-life grandiosity and some scandalous speculation about the erotic lives of Adam, Medea and Jesus, among others.” —<i>Publishers Weekly</i><br/>  <br/> “Subversive and quite funny . . . A fictional absolution of women known historically as ‘whores’ . . . framed by a deadly serious look at erotic history and a formidable exploration of the power of words and their interpretation to alter our existence.” —<i>Booklist</i><br/>  <br/> “Rechy writes gracefully, and sometimes poignantly, of the fate of fallen women over the centuries.” —<i>The Washington Post</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Rechy
      </h2>
      
      <p class="authorDescription body article">John Rechy teaches literature and film courses in the Graduate Writing Program at the University of Southern California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove/Atlantic, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4835b7a6